import type { FC } from 'react';

import { Button, Icon } from '@livechat/design-system-react-components';
import { GmailColored, OutlookColored } from '@livechat/design-system-icons';

import AppleIcon from '_assets/images/email-providers/apple-icon.svg?react';
import YahooIcon from '_assets/images/email-providers/yahoo-icon.png';
import { EmailDomain } from 'types/domains';

import * as styles from './styles';

export const ALLOWED_DOMAINS = [
  EmailDomain.Gmail,
  EmailDomain.Apple,
  EmailDomain.Outlook,
  EmailDomain.Yahoo,
];

type Props = {
  domain: string;
};

export const OpenEmail: FC<Props> = ({ domain }) => {
  const isAllowedDomain = ALLOWED_DOMAINS.includes(domain as EmailDomain);

  const getEmailIcon = (domainName: string) => {
    switch (domainName) {
      case EmailDomain.Apple:
        return <AppleIcon />;
      case EmailDomain.Gmail:
        return <Icon source={GmailColored} size="medium" />;
      case EmailDomain.Outlook:
        return <Icon source={OutlookColored} size="medium" />;
      case EmailDomain.Yahoo:
        return <img src={YahooIcon} alt="Yahoo Icon" />;
      default:
        return null;
    }
  };

  const getEmailLink = (domainName: string) => {
    switch (domainName) {
      case EmailDomain.Apple:
        return 'https://www.icloud.com/mail/';
      case EmailDomain.Gmail:
        return 'https://mail.google.com/mail/#search/from%3A%40livechat+in%3Aanywhere+newer_than%3A1d';
      case EmailDomain.Outlook:
        return 'https://outlook.live.com/mail/0/';
      case EmailDomain.Yahoo:
        return 'https://mail.yahoo.com/d/search/keyword=from%253Alivechat';
      default:
        return null;
    }
  };

  return (
    <div>
      {isAllowedDomain ? (
        <Button
          href={getEmailLink(domain)}
          rel="noopener noreferrer"
          target="_blank"
          kind="secondary"
          size="large"
          icon={getEmailIcon(domain)}
          data-testid={`open-email-button-${domain
            .replace(/[^\w\s]/gi, '')
            .replace(/\s+/g, '-')
            .toLowerCase()}`}
        >
          Open {domain}
        </Button>
      ) : (
        <div css={styles.buttonsContainer}>
          {ALLOWED_DOMAINS.map((domainName) => (
            <Button
              href={getEmailLink(domainName)}
              rel="noopener noreferrer"
              target="_blank"
              kind="secondary"
              size="large"
              icon={getEmailIcon(domainName)}
              key={domainName}
              data-testid={`open-email-button-${domainName
                .replace(/[^\w\s]/gi, '')
                .replace(/\s+/g, '-')
                .toLowerCase()}`}
            >
              Open {domainName}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};
